<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>充值</el-breadcrumb-item>
      <el-breadcrumb-item>玩家充值记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="page-content">
    <el-row @keyup.enter.native="loadData(1)">
      <el-input v-model="queryField.user_id" size="small" placeholder="玩家id"></el-input>
      <el-input v-model="queryField.user_name" size="small" placeholder="玩家账号"></el-input>
      <el-date-picker
              v-model="queryField.time"
              size="small"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
      </el-date-picker>
      <el-button type="primary" size="small" @click="loadData(1)">查询</el-button>
    </el-row>
    <el-table class="cps-table-data"
            :data="tableData" size="small"
            border :height="height"
            style="width: 100%">
      <el-table-column
              prop="user_id"
              label="玩家id"
              width="80">
      </el-table-column>
      <el-table-column
          prop="user_name"
          label="玩家账号"
          width="230">
      </el-table-column>
      <el-table-column
          prop="nick_name"
          label="玩家昵称"
          width="230">
      </el-table-column>
      <el-table-column
          prop="game_name"
          label="游戏名称"
          width="120">
      </el-table-column>
 <!--     <el-table-column
              prop="change_type"
              label="变动类型"
              width="120">
      </el-table-column>-->
      <el-table-column
          prop="before_balance"
          label="变动前余额"
          width="120">
      </el-table-column>
      <el-table-column
          prop="after_balance"
          label="变动后余额"
          width="120">
      </el-table-column>
      <el-table-column
              prop="add_time"
              label="变更时间"
              width="160">
      </el-table-column>

    </el-table>
    <el-pagination class="fixed-pagination"
            @current-change="loadData"
            background
            :page-size="15"
            :current-page="currentIndex"
            layout="total, prev, pager, next"
            :total="total">
    </el-pagination>
    </div>
  </div>
</template>
<script>
  import { userRechargeList } from '@/api/request'
  export default {
    name: 'userCoinLogList',
    data() {
      return {
        tableData: [],
        total: 0,
        queryField: {
          user_id: '',
          user_name: '',
          time: [],
          start_time: '',
          end_time: ''
        },
        currentIndex:1,
        height: window.innerHeight - 210,
      };
    },
    mounted() {
      this.loadData(1);
    },
    methods: {
      loadData(index) {
        if (this.queryField.time != null && this.queryField.time.length > 0) {
          this.queryField.start_time = this.queryField.time[0] + " 00:00:00";
          this.queryField.end_time = this.queryField.time[1] + " 23:59:59";
        }
        else {
          this.queryField.start_time = "";
          this.queryField.end_time = "";
        }
        let params = {
          pageNo: index,
          pageSize: 15,
          params : this.queryField,
        }
        userRechargeList(params).then(res => {
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.currentIndex=index
        });
      },
      detail(row) {
        console.log(row)
      },
    },
  }
</script>
<style lang="scss" scoped>
  /deep/ .is-active {
    background-color: unset !important;
  }
</style>
